// TODO: Fix issues reported by ESLint
/* eslint-disable no-return-assign */
/* eslint-disable consistent-return */
import { observable, action, computed, reaction } from 'mobx';
import * as pubSub from '../../../common/utils/pub-sub.js';
import { PRODUCT_SELECTOR_INIT } from '../../../common/constants/events.js';
import { Group } from './Group.js';
import * as constants from '../../../constants/constants';
import { htmlUnEscape } from '../../../common/helpers/tagged-html.js';

class GroupConfigurations extends Group {
  @observable quantity = 1;

  @observable isShown = false;

  // price of all product subtotals with group quantity = 1
  @observable price = 0;

  @observable isEditMode = false;

  @observable name = '';

  @observable isClipboardNotify = false;

  codification = '';

  constructor({ item, rootStore, shouldExpandGroup = false }) {
    super({ item, rootStore, shouldSyncAPI: true });

    this.updateGroupName = this.updateGroupName.bind(this);
    this.updateGroupQuantity = this.updateGroupQuantity.bind(this);
    this.initCards = this.initCards.bind(this);
    this.remove = this.remove.bind(this);

    this.initCards(item.products);
    this.hiveId = item.hiveId;
    this.name = htmlUnEscape(item.name);
    this.backURL = item.backURL;
    this.price = this.subtotal;
    this.currency = rootStore.optionsStore.currency;
    this.configurationMasterId = item.configurationMasterId || '';

    this.codification = item.codification || '';
    if (this.codification) {
      pubSub.publish(PRODUCT_SELECTOR_INIT);
    }

    if (shouldExpandGroup) {
      this.toggleGroup();
    }

    this.updateGroupQuantity();
    reaction(() => this.quantity, this.updateGroupQuantity);
    reaction(() => this.name, this.updateGroupName);
  }

  initCards(products) {
    this.addCards({ products, shouldSyncAPI: false, skipQtyValidation: true });
  }

  updateGroupQuantity() {
    this.products.forEach((card) => card.changePublicQty(card.baseQuantity * this.quantity));
  }

  updateGroupName() {
    if (this.name === this.previousName) {
      return;
    }

    this.rootStore.services.myProductsAPI.changeGroupName(this.ID, this.name).catch(() => {
      this.name = this.previousName;
    });
  }

  remove({ withoutConfirm = false } = { withoutConfirm: false }) {
    if (this.isDisabled) {
      return;
    }

    return this.rootStore.cartStore.removeGroup({ item: this, withoutConfirm });
  }

  @action.bound
  showClipboardNotify() {
    this.isClipboardNotify = true;
    constants.hideEventsArr.forEach((eventType) => {
      window.addEventListener(
        eventType,
        this.hideClipboardNotify,
        eventType === 'touchstart' ? { passive: true } : false,
      );
    });
    setTimeout(this.hideClipboardNotify, constants.notifyTime);
  }

  @action.bound
  hideClipboardNotify() {
    constants.hideEventsArr.forEach((eventType) => {
      window.removeEventListener(
        eventType,
        this.hideClipboardNotify,
        eventType === 'touchstart' ? { passive: true } : false,
      );
    });
    this.isClipboardNotify = false;
  }

  @action.bound
  changeEditMode(nextMode) {
    if (this.isDisabled) {
      return;
    }

    if (!nextMode || typeof nextMode !== 'boolean') {
      this.isEditMode = !this.isEditMode;
      return;
    }

    this.isEditMode = nextMode;
    if (this.isEditMode) {
      this.previousName = this.name;
    }
  }

  @action.bound
  changeValue(nextName = this.name) {
    if (!nextName.trim()) {
      return;
    }

    this.name = nextName;
  }

  @action.bound
  changeQty(value) {
    super.changeQty(value);
  }

  @action.bound
  toggleGroup() {
    this.isShown = !this.isShown;
  }

  @computed
  get subtotal() {
    let noPrice = 1;

    return this.products.reduce((summ, nextItem) => {
      if (!nextItem.subtotal) {
        noPrice = 0;
        summ = 0;
      }

      return (summ += nextItem.subtotal * noPrice);
    }, 0);
  }
}

export { GroupConfigurations };
